import ApolloClient from "apollo-client";
import { setContext } from "apollo-link-context";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { Auth } from "aws-amplify";
import { toIdValue } from "apollo-utilities";
import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import introspectionQueryResultData from "./fragmentTypes.json";
import { withClientState } from "apollo-link-state";
import { ApolloLink } from "apollo-link";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const dataIdFromObject = object => object.id;

const cache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject,
  cacheRedirects: {
    Query: {
      node: (obj, args) => {
        return toIdValue(dataIdFromObject(args));
      }
    }
  }
});

const stateLink = withClientState({
  cache,
  resolvers: {
    Mutation: {
      updateNetworkStatus: (obj, { input }, { cache }) => {
        const data = {
          networkStatus: {
            id: "NetworkStatus",
            __typename: "NetworkStatus",
            analRunning: false,
            searchRunning: false,
            ...input
          }
        };
        cache.writeData({ data });
        return null;
      }
    }
  },
  defaults: {
    networkStatus: {
      id: "NetworkStatus",
      __typename: "NetworkStatus",
      analRunning: false,
      searchRunning: false
    }
  }
});

const httpLink = createHttpLink({
  uri:
    process.env.NODE_ENV === "production"
      ? "https://9suoa1a1m6.execute-api.us-east-2.amazonaws.com/production/graphql"
      : "http://localhost:4000/graphql",
  headers: { "Accept-Encoding": "gzip" }
});

//TODO:  need to cache token
const authLink = setContext(
  request =>
    new Promise((resolve, reject) => {
      Auth.currentSession().then(session => {
        const token = session.idToken.jwtToken;
        resolve({
          headers: { Authorization: token }
        });
      });
    })
);

const client = new ApolloClient({
  link: ApolloLink.from([authLink, stateLink, httpLink]),
  cache
});

export default client;



// WEBPACK FOOTER //
// ./src/apolloClient.js